import { useMemo } from 'react';
import { useBoardCoreData } from '../../providers';
export const useMetrics = () => {
  const context = useBoardCoreData();
  return useMemo(() => {
    return context.appMetrics;
  }, [context]);
};